import Colors from '@/v2/constants/Colors';
import styled, { css } from 'styled-components';

export const StyledCheckbox = styled.div`
  width: 18px;
  height: 18px;
  background: white;
  border: 2px solid ${Colors.NEUTRAL_VARIANTS[100]};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  cursor: pointer;
  position: relative;
  padding: 2px;

  &::after {
    content: '';
    width: 40px;
    height: 40px;
    border-radius: 100px;
    background-color: ${Colors.BLUE}1a;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.2s;
  }

  &:hover {
    border-color: ${Colors.BLUE};
    &::after {
      opacity: 1;
    }
  }

  ${({ checked }) =>
    checked
      ? css`
          background: ${Colors.BLUE};
          color: white;
          border-color: ${Colors.BLUE};
        `
      : ''};

  ${({ disabled }) =>
    disabled
      ? css`
          cursor: not-allowed;
          opacity: 0.5;
          border-color: ${Colors.NEUTRAL_VARIANTS[80]} !important;
          background-color: ${Colors.NEUTRAL_VARIANTS[30]};

          ::after {
            opacity: 0;
          }
        `
      : ''};
`;
